// Single source of truth for the brand mark. Renders the logo.png from /public.
// Pass `size` to control height in pixels (width auto). Default tightly sized for sidebars/headers.

const Logo = ({ size = 28, className = "", showText = false, dark = false }) => {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img
        src="/logo.png"
        alt="roster.ai"
        height={size}
        style={{ height: `${size}px`, width: "auto" }}
        className={dark ? "brightness-110 contrast-110" : ""}
      />
      {showText && (
        <span className="sr-only">roster.ai</span>
      )}
    </span>
  );
};

export default Logo;
